var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terms-conditions"},[_c('cms-content',{attrs:{"type":"1","lang":_vm.lang}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }